import { Model } from "@interfaces/model.interface";

export interface FirewallLogFailureReason extends Model {
	isActive: boolean;
	reason: string;
}

export class FirewallLogFailureReason implements FirewallLogFailureReason {

	constructor(data?: Partial<FirewallLogFailureReason>) {
		if (data) {
			for (const key of Object.keys(data)) {
				(this as any)[key] = (data as any)[key];
			}
		}
	}
}